module.exports = __webpack_public_path__ + "static/11-478a97bcb859c3f327714f110e5b79c5.jpg";